import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
  HeaderFilters,
  HttpService,
  LocalStorageService,
  MenuBreadCrumb,
  MessageService,
  params,
  SessionService,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';
import { GeneratePdfFosilService } from 'src/app/services/generate-pdf-fosil.service';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { WorkOrderService } from 'src/app/services/work-order.service';
import { WorkOrder } from 'src/app/models/maintenance/work-order';
import { CommentService } from 'src/app/services/comment.service';
import { UntypedFormControl } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
    selector: 'app-maintenance-orders',
    templateUrl: './maintenance-orders.component.html',
    styleUrls: ['./maintenance-orders.component.scss'],
    standalone: false
})
export class MaintenanceOrdersComponent implements OnInit {
  @Input() matTabTitle: string = 'Ordenes de trabajo por autorizar'; 
  @Input() configurationOT: TableConfiguration = {
    edit: true,
    add: true,
    delete: true,
    selectable: true,
    addPer: true,
    editPer: true,
    primaryKey: 'id',
    print: true,
    addComment: true,
    view: true,
  };
  @Input() columnasOT: TableColumns<WorkOrder>[] = [
    {
      ID: 'consecutive',
      label: '#',
      type: 'text',
      style: {
        textAlign: 'center',
        width: '80px',
        movil: 'no-movil',
      },
    },
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'equipmentBrand',
      label: 'Marca',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'component',
      label: 'Componente',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'description',
      label: 'Descripción',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'maintenanceType',
      label: 'Tipo Mtto',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'executionDate',
      label: 'Fecha',
      type: 'fecha',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'invoiceReference',
      label: 'Ref. Factura',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'authorizes',
      label: 'Autoriza',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];
  public inventoryModule: boolean
  @Input() params: params[] = [
    { id: 'equipmentId', value: '0' },
    { id: 'active', value: '1' },
    { id: 'authorized', value: '0' },
  ];

  @Output() addComment = new EventEmitter<WorkOrder[]>();
  @Output() viewDetail = new EventEmitter<WorkOrder>();

  public urlTablaOT: string = `${EndpointDictionary.WorkOrder.WORK_ORDER_TABLE}`;
  private urlPostOT: string = `${EndpointDictionary.WorkOrder.CRUD_WORK_ORDER_DATA}`;
  private urlComboEquipo: string = `${EndpointDictionary.Equipment.EQUIPMENT_COMBO}`;

  private size: number = 90;
  private rol: string
  public selected = new UntypedFormControl(0);
  public detailsClickRow: WorkOrder;

  //tabla ordenes de trabajo
  public recargarTablaOT = new EventEmitter<any>();
  public dataOT: WorkOrder[] = [];

  headerFilters: Array<HeaderFilters> = [
    {
      tN: 'equipos',
      labelFilter: 'Equipo',
      urlData: this.urlComboEquipo,
      visibleField: 'code',
      primaryKey: 'id',
      type: 'select',
      value: '',
    },
    {
      tN: 'ordenes_trabajo',
      labelFilter: 'Fecha Ejecución',
      visibleField: 'fecha_ejecucion',
      type: 'date',
      value: '',
    },
    {
      tN: 'ordenes_trabajo',
      labelFilter: 'Fecha Ejecución Entre',
      visibleField: 'fecha_ejecucion',
      type: 'dateRange',
      value: '',
    },
  ];

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Orden de trabajo',
      current: true,
    },
  ];

  constructor(
    public dialog: MatDialog,
    private session: SessionService,
    private message: MessageService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private generatePdf: GeneratePdfFosilService,
    private deleteItem: DeleteGenericService,
    private storage: LocalStorageService,
    private notificationService: NotificationsService,
    private workOrderService: WorkOrderService,
    private commentService: CommentService
  ) {
    this.inventoryModule = this.storage.get<boolean>('inventory_module');
    this.rol = this.storage.get<string>('rol')
  }

  ngOnInit(): void {
    if (screen.height > 830) {
      this.size = 70;
    }
    if (this.rol === 'Almacenista') {
      this.configurationOT.edit = false;
      this.configurationOT.delete = false;
    }
  }

  back($event: MatTabChangeEvent) {
    switch ($event.index) {
      case 0:
        this.selected.setValue(0);
        break;
      case 1:
        this.selected.setValue(1);
        break;
      default:
        break;
    }
  }

  agregarOT() {
    //console.log($event)
    this.session.setData('data', { action: 'add' });
    this.router.navigate(['detalle'], { relativeTo: this.activeRoute });
  }

  async editarOT($event: WorkOrder[]) {
    let res: boolean = await this.workOrderService.editOT($event[0].id);
    if (res) {
      this.router.navigate(['detalle'], { relativeTo: this.activeRoute });
    }
  }

  async eliminarOT($event: WorkOrder[]) {
    let res = await this.deleteItem.deleteD($event, this.urlPostOT, 'id');
    if (res) {
      let urlNotifications: Array<string> = [];
      for (const i of $event) {
        urlNotifications.push(
          `notificaciones/autorizacion?id_orden_trabajo=${i.id}`
        );
        urlNotifications.push(
          `notificaciones/despacho?id_orden_trabajo=${i.id}`
        );
        urlNotifications.push(
          `notificaciones/ejecucion?id_orden_trabajo=${i.id}`
        );
      }
      this.notificationService.deleteNotificationsByUrl(urlNotifications);
      this.message.closeLoading();
      this.message.SuccessToast('Orden eliminada correctamente');
      this.recargarTablaOT.emit();
    } else {
      this.recargarTablaOT.emit();
    }
  }

  addCommentService($event: WorkOrder[]) {
    this.commentService.addComment($event[0].id);
    // this.addComment.emit($event);
  }

  viewDetailService($event: WorkOrder[]) {
    this.detailsClickRow = $event[0];
    this.selected.setValue(1);
    //this.viewDetail.emit($event[0]);
  }

  seleccionadosOT($event) {
    //console.log($event)
  }

  async clickFilaOT($event: WorkOrder) {
    
    //To do validar la elimnacion de la notificacion de autorizacion ya que desde aca no se elimina
    //   if($event.authorized == 0){
    //   this.message.Warning('Autorizar Orden', '¿Desea autorizar la orden?', true).then( (res) => {
    //     if (res){
    //       let notification : Notification = {
    //         id:-1,
    //         url:`mantenimiento/orden_trabajo/autorizacion?id_orden_trabajo=${$event.id}`
    //       }
    //       this.notificationService.handlerNotification(notification)
    //     }
    //   })
    // }else{
    //}
  }

  packOff($event: WorkOrder[]) {
    if (
      $event[0].authorized == 1 &&
      $event[0].readyResources.toString() == 'No'
    ) {
      this.router.navigate(['/notificaciones/despacho'], {
        queryParams: { id_orden_trabajo: $event[0].id },
      });
    }
  }

  async print($event: WorkOrder[]) {
    this.generatePdf.printTemplateOt($event[0].id);
  }
}
